import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getFortnoxCustomers = (token: string, backend: string, page, sortBy, sortOrder, search) => {
    return fetch(`${getApiUrl(backend)}get_fortnox_customers/${page}?sortBy=${sortBy}&sortOrder=${sortOrder}&search=${search}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getFortnoxCustomers